import moment from 'moment';

'use strict';
import {module} from '../app';

module.service('Worklist', [
  '$http', 'authService', 'signalrService', 'fingerprintService',
  function ($http, authService, signalrService, fingerprintService) {

    let magviewHistoryApiUrl = 'api/magviewhistory';
    let ultraSoundApiUrl = 'api/ultrasoundScanTechnique';
    //let magviewHistoryApiUrl = 'magview.api/magviewhistory';

    let Worklist = {
      getAll: function (filterObj, isSyncWithMagview) {        
        let data = filterObj || {
          pageIndex: 0,
          search: '',
          filtersSet: '',
          showAll: true,
          showMyExamsOnly: false,
          showTodayExamsOnly: false};
        data.clientDate = moment().format().substr(0, 10);
        data.selectedLocations = filterObj.selectedLocations && !filterObj.selectedLocations.some(_ => _ === 'All') ? filterObj.selectedLocations : [];
        data.selectedStatuses = filterObj.selectedStatuses ? filterObj.selectedStatuses : [];
        data.selectedExamTypes = filterObj.selectedExamTypes && !filterObj.selectedExamTypes.some(_ => _ === 'All') ? filterObj.selectedExamTypes : [];
        data.selectedVisitTypes = filterObj.selectedVisitTypes ? filterObj.selectedVisitTypes : [];
        data.isSyncWithMagview = isSyncWithMagview;
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/getAll', data);
      },

      getPatientInfo: function (id) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/' + id);
      },

      getPatientByWorklist: function(id) {
        const getPatientUrl = `${authService.currentMagViewUrl()}/api/worklist/GetPatientByWorklist`;
        const model = { id };
        return $http.post(getPatientUrl, model);
      },

      getPatientComments: function (id) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/' + id + '/comments');
      },

      getPatientInfoBySsn: function (ssn, sdate) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/?ssn=' + ssn + '&sdate=' + sdate);
      },

      getAllLookups: function (includeInternal = false) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/all', {
            params: {
                includeInternal: includeInternal
            }
        });
    },

      getTechnologists: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Technologists');
      },

      getVisitReasons: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/VisitReasons');
      },

      getTecknologists: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Tecknologists');
      },

      getProblems: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Problems');
      },

      getProcedures: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Procedures');
      },

      getViews: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Views');
      },

      getUdfs: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/Udfs');
      },

      getLocations: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Locations');
      },

      getExamTypes: function(){
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/ExamTypes');
      },

      getExamTypesInGroups: function(examTypeGroups){
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/lookup/ExamTypesInGroups', {examTypeGroups});
      },

      getAllLocations: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/lookup/Locations?includeInternal=true');
      },
      readyForExam: function(surveyQueueId){
        return $http.post(authService.currentMagViewUrl() + "/api/HistoryPortal/ReadyForExam", {SurveyQueueId: surveyQueueId});
      },
      getUltraSoundScanOptions: async function() {
        return $http.get(`${authService.currentMagViewUrl()}/${ultraSoundApiUrl}/options`);
      },

      getUltraSoundScanResults: async function(ssn, sDate) {
        const url = `${authService.currentMagViewUrl()}/${ultraSoundApiUrl}/loadScanResults`;
        return $http.post(url, { ssn, sDate });
      },

      saveUltraSoundScanResults: async function (data) {
        const url = `${authService.currentMagViewUrl()}/${ultraSoundApiUrl}/saveScanResults`;
        return $http.post(url, data);
      },

      deleteUltrasoundTechnique: async function(id){
        return $http.delete(`${authService.currentMagViewUrl()}/${ultraSoundApiUrl}/delete/${id}`);
      },

      getHistoryConfigAndData: async function(ssn, sDate, rightHistoryTypes, isIncudeConfig, isIncudeImplants) {
        const url = `${authService.currentMagViewUrl()}/${magviewHistoryApiUrl}/HistoryConfigAndData`;
        let params = {
          ssn, sDate
        };
        if (isIncudeConfig !== undefined) {
          params.isIncudeConfig = isIncudeConfig;
        }
        if (isIncudeImplants !== undefined) {
          params.isIncudeImplants = isIncudeImplants;
        }
        if (rightHistoryTypes && rightHistoryTypes.length > 0) {
          params.types = [];
          for (let type of (rightHistoryTypes || [])) {
            params.types.push(type);
          }
        }
        return $http.post(url, params);
      },

      getHistoryConfig: function (ssn) {
        return $http.get(authService.currentMagViewUrl() + '/' + magviewHistoryApiUrl + '/config?ssn=' + ssn);
      },

      getImplantData: function (ssn, sDate) {
        return $http.get(authService.currentMagViewUrl() + '/' + magviewHistoryApiUrl + '/implantData?ssn=' + ssn + '&sDate=' + sDate);
      },

      deleteRightHistoryRecord: function (model) {
        return $http.post(authService.currentMagViewUrl() + '/' + magviewHistoryApiUrl + '/DeleteRightHistoryData', model);
      },

      getLeftHistoryData: function (ssn, sDate) {
        return $http.get(authService.currentMagViewUrl() + '/' + magviewHistoryApiUrl + '/leftHistoryData?ssn=' + ssn + '&sDate=' + sDate);
      },

      getRightHistoryData: function (ssn, sDate, types) {
        var url = authService.currentMagViewUrl() + '/' + magviewHistoryApiUrl + '/rightHistoryData?ssn=' + ssn + '&sDate=' + sDate;
        types.forEach(function (x) {
          url += '&types=' + x;
        });
        return $http.get(url);
      },

      sendToMyriad: function(ssn, sdate, isOfferedDateChanged = false){
        const url = `${authService.currentMagViewUrl()}/${magviewHistoryApiUrl}/SendToMyriad`;
        const body = {
          ssn: ssn,
          sdate: sdate,
          isOfferedDateChanged: isOfferedDateChanged
        };
        
        return $http.post(url, body);
      },

      skippedSendToMyriad: function (ssn, sdate) {
        const url = `${authService.currentMagViewUrl()}/${magviewHistoryApiUrl}/SkippedSendToMyriad`;
        const body = {
          ssn: ssn,
          sdate: sdate
        };

        return $http.post(url, body);
      },

      saveChanges: function (model) {
        return $http.put(authService.currentMagViewUrl() + '/api/worklist/SaveItem', model);
      },

      updateStatus: function (id, status) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/UpdateStatus?status=' + status);
      },

      updateListMessage: function (id, listMessage) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/updateListMessage?listMessage=' + listMessage);
      },

      updateResource: function(id, resource){
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/updateResource?resource=' + encodeURIComponent(resource));
      },

      endExam: function (id) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/endExam');
      },

      remove: function (id) {
        return $http.delete(authService.currentMagViewUrl() + '/api/worklist/' + id);
      },

      processCreatedRIS: function (id) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/processCreatedRIS');
      },

      isAssignedToMe: function (id) {
        const url = `${authService.currentMagViewUrl()}/api/worklist/${id}/isAssignedToMe`;
        return $http.get(url);
      },

      assignToMe: function (id, isTakeOwnership, isSkipLockingStudy) {
        return fingerprintService.getFingerprint().then(fingerprint => {
          var url = `${authService.currentMagViewUrl()}/api/worklist/${id}/assignToMe?isSkipLockingStudy=${!!isSkipLockingStudy}`;
          if (isTakeOwnership) {
            url = `${url}&forceAssign=true`;
          }
          const body = { fingerprint: fingerprint };
          return $http.post(url, body);
        });
      },

      checkStudyLock: function (id) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/checkStudyLock');
      },

      checkSameDayStudiesLock: function (id) {
        return $http.post(`${authService.currentMagViewUrl()}/api/worklist/${id}/checkSameDayStudiesLock`);
      },

      overwriteAudit: function (id) {
        return $http.post(`${authService.currentMagViewUrl()}/api/worklist/${id}/overwriteAudit`);
      },

      getChangeStatusesConfigs: function (worklistId) {
        return $http.get(authService.currentMagViewUrl() + `/api/worklist/getChangeStatusesConfigs?worklistId=${worklistId}`);
      },

      ownWorklist: function (worklistId) {
        return $http.put(authService.currentMagViewUrl() + `/api/worklist/${worklistId}/ownWorklist`);
      },

      getDisplayStatusesConfigs: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/getDisplayStatusesConfigs');
      },

      checkStudyLockBySsnAndSdate: function (studyCompisiteId) {
        return $http.post(authService.currentMagViewUrl() + `/api/worklist/checkStudyLock`, studyCompisiteId);
      },

      checkIfWorklistExists: function(studyCompisiteId){
        return $http.post(authService.currentMagViewUrl() + `/api/worklist/checkIfWorklistExists`, studyCompisiteId);
      },

      applyListMessage: function (worklistId, label) {
        const data = {
          worklistId,
          value: label
        };
        return $http.put(authService.currentMagViewUrl() + '/api/worklist/applyListMessage', data);
      },

      toggleTag: function(worklistId, tag){
        const data = {
          worklistId,
          value: tag
        };
        return $http.put(authService.currentMagViewUrl() + '/api/worklist/toggleTag', data);
      },

      applyAdditionalInfo: function (worklistId, additionalInfo) {
        const data = {
          worklistId,
          value: additionalInfo
        };
        return $http.put(authService.currentMagViewUrl() + '/api/worklist/applyAdditionalInfo', data);
      },

      unassignFromMe: function (id) {
        return fingerprintService.getFingerprint().then(fingerprint => {
          const body = { fingerprint };
          return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/unassign', body);
        });
      },

      unlockExam: function (id) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/unlockExam');
      },

      unlockMyExam: function (id) {
        const url = `${authService.currentMagViewUrl()}/api/worklist/${id}/unlockExam?isUnlockMyExam=true`;
        return $http.post(url);
      },

      getSameDayStudies: function (id) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/' + id + '/getSameDayStudies');
      },

      saveLinkedStudies: function (id, studies) {
        return $http.post(authService.currentMagViewUrl() + '/api/worklist/' + id + '/saveLinkedStudies', studies);
      },
      historyChangedInMagview: function (id) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/historyChangedInMagview/' + id);
      },
      recalculateRisks: function(id){
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/recalculateRisks/' + id);
      },
      getAvailableResources: function(worklistId){
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/getAvailableResources/' + worklistId);
      },

      onEvent: function (name, fun) {

        signalrService.worklist.on(name, fun);

        return {
          unsubscribe: function () {
            signalrService.worklist.off(name, fun);
          }
        };
      },
      itemCreated: null,
      itemUpdated: null,
      itemRemoved: null,
      itemUnlockStatusChanged: null,
      itemRemovedStatusChanged: null,
      onItemCreated: function (func) {
        this.itemCreated = func;
      },
      onItemUpdated: function (func) {
        this.itemUpdated = func;
      },
      // not in use for now
      /*onItemRemoved: function (func) {
        this.itemRemoved = func;
      },*/
      onItemUnlockStatusChanged: function (func) {
        this.itemUnlockStatusChanged = func;
      },
      onItemRemovedStatusChanged: function (func) {
        this.itemRemovedStatusChanged = func;
      },
      getBarcode: function(accession) {
        return $http.get(authService.currentMagViewUrl() + '/api/worklist/getBarcode?accession=' + accession);
      }
    };

    let onWorklistItemCreatedEventHandler = function (item) {
      if (Worklist.itemCreated)
        Worklist.itemCreated(item);
    };

    let onWorklistItemUpdatedEventHandler = function (item) {
      if (Worklist.itemUpdated)
        Worklist.itemUpdated(item);
    };

    let onWorklistItemLockStatusChangedEventHandler = function (item) {
      if (Worklist.itemUnlockStatusChanged)
        Worklist.itemUnlockStatusChanged(item);
    };

    let onWorklistItemRemovedStatusChangedEventHandler = function (item) {
      if (Worklist.itemRemovedStatusChanged)
        Worklist.itemRemovedStatusChanged(item);
    };

    signalrService.worklist.on('itemCreated', onWorklistItemCreatedEventHandler);
    signalrService.worklist.on('itemUpdated', onWorklistItemUpdatedEventHandler);
    //signalrService.worklist.on('itemRemoved', onWorklistItemRemoveEventHandler);
    signalrService.worklist.on('worklistLockStatusChanged', onWorklistItemLockStatusChangedEventHandler);
    signalrService.worklist.on('worklistRemovedStatusChanged', onWorklistItemRemovedStatusChangedEventHandler);

    return Worklist;
  }]);



// WEBPACK FOOTER //
// ./src/scripts/domains/worklist.js